import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderBox from "../reuseableComponents/headerBox";
import CreatePortalAccountForm from "./CreatePortalAccountForm";

const CreatePortalAccount = (props) => {
  return (
    <>
      <Row>
        <Col>
          <Link className='hyperlink' to='/deqWater' cypressid='backtoPublicLink'>
            Home
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='createPortalAccount'>
            <h3 style={{ color: "#fff" }}>Create WaterLink Portal Account</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <CreatePortalAccountForm props={props} />
        </Col>
      </Row>
    </>
  );
};
export default CreatePortalAccount;
